import { api } from "@/frontend/services/api";
import type {
  CreateBettingPoolStatusRequestDTO,
  UpdateBettingPoolStatusRequestDTO,
  BettingPoolStatusResponseDTO,
  BettingPoolStatusesPaginatedResponseDTO,
  ApiResponse,
  PaginationRequestDTO,
} from "@/shared/dto";

const BASE_URL = "/betting-pool-statuses/private";

export const bettingPoolStatusService = {
  getPaginate: (params?: PaginationRequestDTO) => {
    return api.getWithParams<ApiResponse<BettingPoolStatusesPaginatedResponseDTO>>(BASE_URL, params);
  },
  getById: (id?: string) =>
    api.get<ApiResponse<BettingPoolStatusResponseDTO>>(`${BASE_URL}/${id}`),
  create: (data: CreateBettingPoolStatusRequestDTO) =>
    api.post<ApiResponse<BettingPoolStatusResponseDTO>>(BASE_URL, data),
  update: (id: string, data: UpdateBettingPoolStatusRequestDTO) =>
    api.put<ApiResponse<BettingPoolStatusResponseDTO>>(`${BASE_URL}/${id}`, data),
  delete: (id: string) => api.delete<ApiResponse<void>>(`${BASE_URL}/${id}`),
};
